import { useState } from 'react'

interface OtherTextFieldProps {
  onSubmit: (value: string) => void
}

export function OtherTextField({ onSubmit }: OtherTextFieldProps) {
  const [value, setValue] = useState('')

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      if (value.trim()) {
        onSubmit(value.trim())
      }
    }
  }

  return (
    <div className="mt-4 w-full max-w-[585px] md:mt-6">
      <textarea
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Please specify..."
        className="min-h-[60px] w-full rounded-md border border-gray-600 bg-transparent px-3 py-2 text-sm text-white placeholder:text-gray-400 focus:border-gray-400 focus:outline-hidden"
        autoFocus
      />
      <p className="mt-2 text-xs text-gray-500">Press Enter to continue</p>
    </div>
  )
}
